<div class="mt-20">
  <div class="row middle-xs">
    <div class="col-xs-3">
      <div [id]="identifierService.labelId('followupSchedule', 'followSched')" class="pageTitle" data-tx-key="label.gb.follow_sched">{{ labels['label.gb.follow_sched'] }}</div>
    </div>
    <div class="col-xs-3">
      @if (profileMode()) {
        <div>
          @if (viewMode()) {
            <button mat-raised-button color="primary" style="margin-right: 5px" (click)="setDisplayMode('edit')" id="profileEditButton" [disabled]="!hasPatientDataEntryAccess"
              data-tx-key="label.gb.edit" aria-label="{{ labels['label.gb.edit'] }}">
              {{ labels['label.gb.edit'] }}
            </button>
          }
          @if (editMode()) {
            <button mat-raised-button class="mr-20" color="accent" (click)="cancelEditClick()" id="profileCancelButton"
                    data-tx-key="label.gb.button_cancel">
              {{ labels['label.gb.button_cancel'] }}
            </button>
          }
          @if (editMode()) {
            <button mat-raised-button color="primary" class="mr-5" (click)="onSaveButtonClick(false)" id="profileSaveButton">
              @if (
                followupScheduleForm.get('schedulingMethodCd').value == 511) {
                <div [id]="identifierService.labelId('followupSchedule', 'save')" data-tx-key="label.gb.save"> {{ labels['label.gb.save'] }} </div>
              } @else {
                {{ labels['label.gb.save'] }}
              }
            </button>
          }
        </div>
      }
    </div>
    <div class="col-xs-offset-1 col-xs-5 end-xs">
      @if (profileMode()) {
        <div class="controls tool-flexx">
          <div class="figLink" style="margin-left: 10px; margin-top: 10px" id="printProfileLink" (click)="openPrintDialog()"
            data-tx-key="label.gb.print_profile">
            {{ labels['label.gb.print_profile'] }}
          </div>
          @if (viewMode()) {
<div class="figLink" style="margin-left: 10px; margin-top: 10px" [ngStyle]="{
                    'pointer-events': isSP2CanEnroll ? 'auto' : 'none',
                    color: isSP2CanEnroll ? '#03a9f4' : '#9e9e9e'
                }" id="releasePatientLink" (click)="releasePatient()">
              {{ labels['label.gb.release_patient'] }}
            </div>
          }
          @if (viewMode()) {
            <div class="figLink" style="margin-left: 10px; margin-top: 10px" id="moreActionsLink">
              <a [id]="identifierService.buttonId('followupSchedule', 'moreActions')" [matMenuTriggerFor]="menu" #trigger="matMenuTrigger">
                {{ labels['label.gb.more_actions'] }} &#8942;
              </a>
            </div>
          }
        </div>
      }
    </div>
  </div>
  <mat-menu #menu="matMenu">
    <button mat-menu-item id="reactivatePatientButton" (click)="reActivatePatient()" [disabled]="!hasPatientDataEntryAccess"
      data-tx-key="label.gb.reactivate_pat">
      {{ labels['label.gb.reactivate_pat'] }}
    </button>
  </mat-menu>
  <br />
  @if (displayMode == 'view') {
    <div>
      @if (isPatientRelease) {
        <div class="yellow-card">
          <span [id]="identifierService.labelId('followupSch', 'releasePatientMsg')" [innerHTML]="releasePatientMsg"></span>
        </div>
      }
    </div>
  }

  @if (dataLoaded) {
    <mat-card appearance="outlined" class="flat mt-10">
      <div class="row">
        <div class="col-xs-2">
          <div>
            <h3 [id]="identifierService.labelId('followupSchedule', 'schedulingMethod')" class="merlin-header" data-tx-key="label.gb.scheduling_method">{{ labels['label.gb.scheduling_method'] }}</h3>
          </div>
        </div>
        <div class="col-xs-8" [formGroup]="followupScheduleForm">
          <mat-radio-group aria-label="Select an option" formControlName="schedulingMethodCd" [disabled]="viewModeDisable()" id="scheduleModeGroup">
            @for (method of schdMethodCodes; track method) {
              <mat-radio-button class="mr-30" id="smartModeRadioButton{{method.codeId}}" [value]="method.codeId">
                <span
                  [id]="identifierService.labelId('followupSch', 'schedMethod_' + method.code)"
                  [innerHTML]="labels['data.Code.Scheduling_Method_Cd.Code_Desc.' + method.code] | safe: 'html'"
                ></span>
              </mat-radio-button>
            }
          </mat-radio-group>
        </div>
        <div class="col-xs-2">
          @if (viewScheduleLink()) {
            <div [id]="identifierService.buttonId('followupSchedule', 'viewSchedule')" class="figLink viewSchedule" (click)="openViewScheduleDialog()" data-tx-key="label.gb.view_schedule">
              {{ labels['label.gb.view_schedule'] }}
            </div>
          } @else {
            @if (followupScheduleForm.get('schedulingMethodCd').value  == '511' && displayMode == 'edit') {
              <div [id]="identifierService.buttonId('followupSchedule', 'viewScheduleEdit')" class="figLink viewSchedule"
                (click)="openViewScheduleDialog()" data-tx-key="label.gb.view_schedule">
                {{ labels['label.gb.view_schedule'] }}
              </div>
            }
          }
        </div>
      </div>
      <!-- None Schedule Type Display -->
      @if (followupScheduleForm.get('schedulingMethodCd').value  == '511') {
        <div class="scheduleContainer">
          <div class="row">
            <div class="col-xs-12 mt-20">
              <div class="cardText" [id]="identifierService.labelId('followupSch', 'noSchedTransmission')" [innerHTML]=noScheduledTransmissionHtml data-tx-key="msg.gb.manual_sched_prompt"></div>
            </div>
          </div>
        </div>
      }
      <!-- Smart Schedule Type Display -->
      @if (followupScheduleForm.get('schedulingMethodCd').value  == 509) {
        <div class="scheduleContainer">
          <app-smart-followup [followupScheduleForm]="followupScheduleForm" [patientData]="patientData" [lastTransMissionDate]="lastTransMissionDate" [datePlaceholder]="datePlaceholder" [tz]="tz" [locale]="locale" (permStartDateString)="onPermStartDateChange($event)" (tempStartDateString)="onTempStartDateChange($event)"></app-smart-followup>
        </div>
      }
      <!-- Manual Schedule Type Display -->
      @if (followupScheduleForm.get('schedulingMethodCd').value == 510) {
        <div class="scheduleContainer">
          <div class="row">
            <div class="col-md-8">
              <app-manual-followup [followupScheduleForm]="followupScheduleForm" [tz]="tz" [lastTransMissionDate]="lastTransMissionDate" [datePlaceholder]="datePlaceholder" [locale]="locale"></app-manual-followup>
            </div>
          </div>
        </div>
      }
    </mat-card>
      @if (!isAveirDevice){
    <mat-card appearance="outlined" class="flat mt-10">
            <div style="
                display: flex;
                justify-content: flex-start;
                align-items: center;
            ">
        <div>
          <h3 [id]="identifierService.labelId('followupSchedule', 'clear')"  class="merlin-header" style="margin-top: 10px" data-tx-key="label.gb.clear">{{ labels['label.gb.clear'] }}</h3>
        </div>
        @if (showOverrideButton()) {
          <button mat-raised-button color="primary" style="margin-left: 15px; margin-right: 5px" id="removeOverridesButton" (click)="removeOverridesClick()"
            [disabled]="viewAndEnrollMode()" data-tx-key="label.gb.remove_overrides">
            {{ labels['label.gb.remove_overrides'] }}
          </button>
        }
      </div>
      <div class="row" style="margin-top: 10px" [formGroup]="patTxSettingsForm">
        <div class="col-xs-12">
          <ul>
            @if (specialTreatDisplay()) {
              <li>
                <mat-checkbox formControlName="clearEgmsFlg" [disabled]="viewModeDisable()" id="storedEGMsCheckbox" (change)="makeDirty($event)" data-tx-key="label.gb.stored_egms">@if (clearOverrideShow('clearEgmsFlg')) {
                  <span>♦ </span>
                  }{{ labels['label.gb.stored_egms'] }}
                </mat-checkbox>
              </li>
            }
            <!-- [disabled]="specialTreatmentEnabled()" -->
            <li>
              @if (statDiagDisplay()) {
                <mat-checkbox formControlName="clearDiagFlg" [disabled]="viewModeDisable()" id="statisticalDiagnosticsCheckbox" (change)="makeDirty($event)" data-tx-key="label.gb.stat_diags">@if (
                  clearOverrideShow(
                  'clearDiagFlg'
                  )
                  ) {
                  <span>♦ </span>
                  }{{ labels['label.gb.stat_diags'] }}
                </mat-checkbox>
              }
            </li>
            @if (specialTreatDisplay()) {
              <li>
                <mat-checkbox formControlName="clearEpisodalDiagnosticsFlg" [disabled]="viewModeDisable()" id="episodealDiagnosticsCheckbox" (change)="makeDirty($event)" data-tx-key="label.gb.episodes">@if (
                  clearOverrideShow(
                  'clearEpisodalDiagnosticsFlg'
                  )
                  ) {
                  <span>♦ </span>
                }{{ labels['label.gb.episodes'] }}</mat-checkbox>
              </li>
            }
            <!-- [disabled]="specialTreatmentEnabled()" -->
            <li>
              @if (ICMDiagEpisEGMDisplay()) {
                <mat-checkbox formControlName="clearEpisodeEgmDiagFlg" [disabled]="viewModeDisable()" id="ICMDiagnosticsEpisodesEGMsCheckbox" (change)="makeDirty($event)" data-tx-key="label.gb.clear_icm_diag_epi_segm">@if (
                  clearOverrideShow('clearEpisodeEgmDiagFlg')
                  ) {
                  <span>♦ </span>
                  }{{ labels['label.gb.clear_icm_diag_epi_segm'] }}
                </mat-checkbox>
              }
            </li>
            <li>
              @if (ICDStDiagnosticsDisplay()) {
                <mat-checkbox formControlName="clearStMonitorFlg" [disabled]="stDiagInclStEgmEnabled()" id="clearStDiagnosticsCheckbox" (change)="makeDirty($event)" data-tx-key="label.gb.st_monitoring">@if (
                  clearOverrideShow(
                  'clearStMonitorFlg'
                  ) && stCapableFlg
                  ) {
                  <span>♦  </span>
                  }{{ labels['label.gb.st_monitoring'] }}
                </mat-checkbox>
              }
            </li>
            <!-- <li>
            <mat-checkbox
                            [(ngModel)]="
                                patientData.patTxSettings.clearStMonitorFlg
                            "
              *ngIf="STMonitorDisplay()"
              [disabled]="stMonitoringEnabled()"
              id="STMonitoringCheckbox"
              ><span
              *ngIf="clearOverrideShow('clearStMonitorFlg')"
              >♦ </span
              >{{
              'label.gb.st_monitoring']
              }}</mat-checkbox
              >
            </li> -->
            <li>
              @if (episAndEGMDisplay()) {
                <mat-checkbox formControlName="clearEpisInclEgmFlg" [disabled]="viewModeDisable()" id="EpisodesEGMsCheckbox" (change)="makeDirty($event)" data-tx-key="label.gb.epis_incl_SEGM">@if (clearOverrideShow('clearEpisInclEgmFlg')) {
                  <span>♦
                  </span>
                  }{{ labels['label.gb.epis_incl_SEGM'] }}
                </mat-checkbox>
              }
            </li>
            @if (specialTreatDisplay()) {
              <li>
                <mat-checkbox formControlName="clearStatsDiagnosticsFlg" [disabled]="viewModeDisable()" id="diagnoticsCheckbox" (change)="makeDirty($event)">@if (clearOverrideShow('clearStatsDiagnosticsFlg')) {
                  <span data-tx-key="label.gb.diagnostics">♦ </span>
                  }{{ labels['label.gb.diagnostics'] }}
                </mat-checkbox>
              </li>
            }
            <!-- [disabled]="specialTreatmentEnabled()" -->
          </ul>
          @if (showOverrideText()) {
            <p style="color: #039be5; margin-top: 10px">
                        <span [id]="identifierService.labelId('followupSch', 'overrideInstrText')" [innerHTML]="
                            labels['label.gb.override_instr_text']
                                | safe: 'html'
                        " data-tx-key="label.gb.override_instr_text"></span>
            </p>
          }
        </div>
      </div>
    </mat-card>
      } @else if (isAveirDevice){
          <p style="color: #039be5; margin-top: 10px">
                        <span [id]="identifierService.labelId('followupSch', 'overrideInstrTextAveir')" [innerHTML]="
                            labels['label.gb.override_instr_text']
                                | safe: 'html'
                        " data-tx-key="label.gb.override_instr_text"></span>
          </p>
      }
    @if (enrollmentMode()) {
      <div style="display: flex; justify-content: flex-end; margin-top: 10px">
        <button mat-raised-button style="margin-left: 5px; margin-right: 5px" color="accent" (click)="backButtonClick()" [id]="
          identifierService.buttonId(
              'followup-schedule',
              'enrollBackButton'
          )
          " data-tx-key="label.gb.back">
          {{ labels['label.gb.back'] }}
        </button>
        <button mat-raised-button style="margin-left: 5px; margin-right: 5px" color="accent" (click)="cancelButtonClick()" [id]="
          identifierService.buttonId(
              'followup-schedule',
              'enrollCancelButton'
          )
          ">
          {{ labels['label.gb.button_cancel'] }}
        </button>
        <button mat-raised-button style="margin-left: 5px; margin-right: 5px" color="accent" (click)="onSaveAndCloseWithXssValidation()" [id]="
          identifierService.buttonId(
              'followup-schedule',
              'enrollSaveAndCloseButton'
          )
          ">
          {{ labels['label.gb.saveandclose'] }}
        </button>
        <button mat-raised-button style="margin-left: 5px" color="primary" (click)="onSaveButtonClick(false)" [id]="
          identifierService.buttonId(
              'followup-schedule',
              'enrollContinueButton'
          )
          ">
          {{ labels['label.gb.continue'] }}
        </button>
      </div>
      <p [id]="identifierService.labelId('followupSchedule', 'requiredField')" style="color:red" data-tx-key="label.gb.required_field">* {{ labels['label.gb.required_field'] }}</p>
    }
    <!-- <button mat-button (click)="onSaveButtonClick(false)">Save</button> -->
  }
</div>
